export default __webpack_public_path__ + "static/media/RouterImg.80b97fdc.png";